import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { Accordion, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { WizardStyles } from "@/components/styles/WizardStyles";
import { VoterInformationLetterPasswordAccess } from "./VoterInformationLetterPasswordAccess";
export var VoterInformationLetterDocumentAccess = function (_a) {
    var taskId = _a.taskId, pdfPassword = _a.pdfPassword, _b = _a.loading, loading = _b === void 0 ? false : _b, onReveal = _a.onReveal, className = _a.className;
    var t = useTranslation().t;
    var _c = useState(true), expanded = _c[0], setExpanded = _c[1];
    useEffect(function () {
        setExpanded(true);
    }, [taskId]);
    useEffect(function () {
        if (pdfPassword) {
            setExpanded(true);
        }
    }, [pdfPassword]);
    return (_jsxs(Accordion, { className: ["voter-information-letter-document-access", className]
            .filter(Boolean)
            .join(" "), sx: { width: "100%" }, expanded: expanded, onChange: function (_, nextExpanded) { return setExpanded(nextExpanded); }, children: [_jsx(AccordionSummary, { className: "voter-information-letter-document-access-summary", expandIcon: _jsx(ExpandMoreIcon, { className: "voter-information-letter-document-access-expand-icon" }), children: _jsx(WizardStyles.AccordionTitle, { className: "voter-information-letter-document-access-title", children: t("tasksScreen.documentAccess.title") }) }), _jsx(WizardStyles.AccordionDetails, { className: "voter-information-letter-document-access-details", children: _jsx(VoterInformationLetterPasswordAccess, { className: "voter-information-letter-document-access-password", pdfPassword: pdfPassword, loading: loading, onReveal: onReveal }) })] }));
};
